// PageVariablesSegurados.js

export const pageVariables = {
    headers: [
        'CPF', 'NOME', 'EMAIL', 'DATA DE NASCIMENTO', 'RG', 'STATUS', 'IDADE', 'CARREIRA','TIPO'
    ],
    headerInfo: {
        title: "Segurados",
        description: "Esta seção fornece informações detalhadas sobre os segurados, incluindo dados como nome, tipo de seguro e status atual. Acompanhe suas apólices e informações de cobertura para garantir que você esteja sempre protegido."
    },
    inputs: [
        {
            name: "cpf",
            type: "text",
            label: "CPF"
        },
        {
            name: "data_nascimento",
            type: "date",
            label: "Data de Nascimento"
        },
        {
            name: "nome",
            type: "text",
            label: "Nome"
        },
        {
            name: "rg",
            type: "text",
            label: "RG"
        },
        {
            name: "email",
            type: "email",
            label: "Email"
        },
        {
            name: "status",
            type: "text",
            label: "Status"
        },
        {
            name: "idade",
            type: "text",
            label: "Idade"
        }
    ],
    extraInput:[
        {
            name: "logradouro",
            type: "text",
            label: "Logradouro"
        },
        {
            name: "numero",
            type: "text",
            label: "Numero"
        },
        {
            name: "complemento",
            type: "text",
            label: "Complemento"
        },{
            name: "bairro",
            type: "text",
            label: "Bairro"
        },
        {
            name: "cidade",
            type: "text",
            label: "Cidade"
        },
        {
            name: "estado",
            type: "text",
            label: "Estado"
        },
        {
            name: "cep",
            type: "text",
            label: "CEP"
        }
    ],
    extraInputName: "Endereço"
    ,
    page: process.env.VUE_APP_API_URL+"segurados",
    pageGetSegurados: process.env.VUE_APP_API_URL+"getSegurados",
    agendamentoAvulsoPage: process.env.VUE_APP_API_URL+"agendamentos/avulso",
    pageBadge: process.env.VUE_APP_API_URL+"badge",
    selectBoxPage: process.env.VUE_APP_API_URL+"empresas-all",
    uploadDataPage: process.env.VUE_APP_API_URL+"uploads",
    uploadUpdatePage:process.env.VUE_APP_API_URL+"uploads/update",
    agendadoresPage: process.env.VUE_APP_API_URL+"get-group-members/agendadores",
    seachFilterKey: "nome"
};
